import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

export const userMeditationsColumns = [
    { field: 'resourceTitle', name: 'Meditation Title', dataType: 'multiselect' },
    { field: 'meditationDatetime', name: 'Meditation Date ({tz} time zone)', dataType: 'datetime' },
    { field: 'meditationLength', name: 'Length (seconds)', dataType: 'numeric' },
];

const UserMeditations = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [...userColumns, ...userMeditationsColumns];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.meditationDatetime),
    //     {
    //         count: true,
    //         sumFields: ['meditationLength'],
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Total Meditations',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    //     {
    //         name: 'Minutes Meditated',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.meditationLengthSum / 60),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart
                    data={chartData}
                    chartTitle="User Meditations Over Time"
                />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows information about user meditation sessions. Each row
                    represents a single meditation activity completed by a user.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Meditation Title">
                    The name of the guided meditation resource or practice that was used.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Meditation Date">
                    The date when the meditation session was completed.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Length (seconds)">
                    The total duration of the meditation session, measured in seconds.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserMeditations;
